import { createBrowserRouter, RouterProvider } from "react-router-dom";
import Root from "./routes/Root";
import Home from "./routes/Home";
import Events from "./components/Events";
import Workshop from "./components/Workshop";
import ErrorRouter from "./ErrorRouter";

const router = createBrowserRouter([
  {
    path: "/",
    element: <Root />,
    errorElement: <ErrorRouter />,
    children: [
      { index: true, element: <Home /> },
      { path: "events", element: <Events /> },
      { path: "workshop", element: <Workshop /> }, // ✅ FIX
    ],
  },
]);

export default function App() {
  return <RouterProvider router={router} />;
}

